import { render, staticRenderFns } from "./ProcessDocumentCardTab.vue?vue&type=template&id=14eb6310"
import script from "./ProcessDocumentCardTab.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentCardTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports